import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import ProjectReminders from "../components/ProjectRemainders";

const NotificationAlertPage = () => {
  return (
  <>

  <Breadcrumb title={"Notifications"}/>
  
  <ProjectReminders />
  </>
  )
};

export default NotificationAlertPage;
